import React from 'react';
import classNames from 'classnames';
// import './CellIconButton.less'
import { IconButton, IIconButtonProps } from 'components/buttons/IconButton';

/**
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export const CellIconButton = React.forwardRef(
  ({ className, ...otherProps }: IIconButtonProps, ref: React.Ref<HTMLButtonElement>) => {
    return <IconButton className={classNames('tt-cell-icon-button')} {...otherProps} ref={ref} />;
  }
);
